export class ClearJobsFiltersLoadingStatus {
    public static readonly type = '[JobsPlacements] Clear jobs filters loading status';
}
